<template>
    <div class="carousel-wrap">
        <div class="img-wrap">
            <ul class="carousel-ul">
                <transition-group name="list">
                    <li v-show="showIndex === index" v-for="(img, index) in imgList" :key="img.id"
                        :class="{'center':imgList.length === 1}">
                        <div>
							<img :height="imgHeight+'px'" @click="itemClick(img)"
								 class="carousel-img" :src="img.image"/>
                        </div>
                    </li>
                </transition-group>
            </ul>
        </div>
        <div class="control-wrap">
            <ul>
                <li v-for="(img, index) in imgList" class="control-slider" :class="{'show-slider': showIndex === index}"
                    @click="mouseClick(index)"></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "v-carousel",
        props: ['imgList', 'imgHeight'],
		watch: {
			// 监听单个props
			imgList(newVal, oldVal) {
			  console.log('imgList：', '旧值=', oldVal, '新值=', newVal);
			},
			// 监听所有props（较少用，适合多props变化的场景）
			$props: {
			  handler(newProps) {
				console.log('所有props更新：', newProps);
			  },
			  deep: true // 深度监听（props里有对象/数组时必须加）
			}
	    },
        data() {
            return {
                href:'',
                showIndex: 0,
                timer: null
            }
        },
        created() {
            this.href = window.location.href;
            this.startCarousel();
        },
        mounted() {
            document.getElementsByClassName('carousel-ul')[0].style.height = this.imgHeight + 'px';
        },
        methods: {
            mouseClick(index) {
                this.showIndex = index;
                this.startCarousel();
            },
            getJumpUrl(img) {
                let url = "";
                if (img.absoluteUrl) {
                    //绝对路径跳转
                    url = img.jumpUrl;
                } else {
                    //相对路径跳转
                    url = this.href + img.jumpUrl;
                }
                window.open(url)
            },
            startCarousel() {
                let that = this;
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (that.showIndex !== that.imgList.length - 1) {
                        that.showIndex += 1;
                    } else {
                        that.showIndex = 0;
                    }
                }, 8000)
            },
			itemClick(item) {
			  this.$router.push({
			    path: "/newsDetail",
			    query: { id: item.articleId },
			  });
			},
        }
    }
</script>

<style lang="less" scoped>
    .carousel-wrap {
        .img-wrap {
            overflow: hidden;
            ul {
                position: relative;
                li {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    div {
                        width: auto;
                        img {
                            width: 100%;
                            cursor: pointer;
                            border-radius: 10px;
							height: auto;     /* 高度根据宽高比自动计算 */
							object-fit: contain; /* 可选：确保图片完整显示，不会裁剪（默认也是这个效果） */
                        }
                    }
                }
                .center {
                    justify-content: center;
                }
            }
            .list-enter-active, .list-leave-active {
                transition: all 0.8s;
            }
            .list-enter {
                transform: translateX(100%);
            }
            .list-leave-to {
                transform: translateX(-100%);
            }
        }
        .control-wrap {
            margin-top: 10px;
            text-align: center;
            ul li {
                display: inline-block;
                width: 40px;
                height: 6px;
                border-radius: 2px;
                margin-right: 10px;
                background: rgba(255,255,255,.5);
                cursor: pointer;
                &:last-of-type {
                    margin-right: 0;
                }
            }
            .show-slider {
                background: rgba(255,255,255,1);
            }
        }
    }
</style>